var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color, black)",
    d: "M10.1716 0.652996C7.79246 0.655532 5.50168 1.55455 3.75589 3.17083C2.01009 4.78711 0.937524 7.00193 0.751973 9.37379C0.566421 11.7457 1.28152 14.1003 2.75473 15.9684C4.22793 17.8365 6.35104 19.0809 8.70081 19.4533V12.8425H6.28166V10.1089H8.70081V8.02707C8.70081 5.65611 10.1056 4.34003 12.2661 4.34003C12.9728 4.35049 13.6774 4.41748 14.3734 4.54036V6.853H13.1891C12.0151 6.853 11.6398 7.58838 11.6398 8.33644V10.1115H14.2694L13.8485 12.8451H11.6423V19.4559C13.9921 19.0834 16.1152 17.8391 17.5884 15.971C19.0616 14.1029 19.7767 11.7482 19.5912 9.37633C19.4056 7.00447 18.333 4.78964 16.5872 3.17336C14.8414 1.55708 12.5507 0.658067 10.1716 0.65553V0.652996Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c1b16b80.svg";
export { ForwardRef as ReactComponent };